import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const EvPowertrainSimulatorGuidePage = () => <DataDrivenGuidePage slug="guide-ev-powertrain-simulator" />;

export default EvPowertrainSimulatorGuidePage;
